// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__XRqaX","footerText":"Footer_footerText__El6u8"};